import React, { useState, useRef } from 'react';
import { Container, Row, Col, Button, ToastHeader, Toast, ToastBody } from 'reactstrap';
import { Field, CancelButton, DeleteButton } from '@galop/component-library';
import { makeCall } from '../../auth-utils';
import Reaptcha from 'reaptcha';
import { api, globalErrorHandler } from '../../api/create-api';
import { useEffect } from 'react';
import { useBSToasts } from '../Shared/BSToasts';
import { getPropertyPhone } from '../Properties/Properties';
import { formatPhoneNumber } from '../../Helpers/Helper';

export const InquiryForm = (props) => {
    const qs = require('qs');
    const config = {
        resourceName: 'inquiry',
        capitalResourceName: 'Inquiry',
        pluralResourceName: function () {
            return this.resourceName + 's';
        },
        pluralCapitalResourceName: function () {
            return this.capitalResourceName + 's';
        },
        writeRole: "admin",
        controllerName: 'inquiries'
    };
    const detailCharacterLimit = 500;
    const propertyIdentifier = qs.parse(window.location.search, { ignoreQueryPrefix: true }).propertyIdentifier || props.propertyIdentifier;
    const [resource, setResource] = useState(props.resource || {});
    const [resourceIsDirty, setResourceIsDirty] = useState(false);
    const [validProperty, setValidProperty] = useState(!!propertyIdentifier);
    const [topics, setTopics] = useState([]);
    const [errors, addError] = useBSToasts([]);
    const [submittedForm, setSubmittedForm] = useState(0);
    const [resourcePhone, setResourcePhone] = useState(null);

    const [submitInquiry, setSubmitInquiry] = useState(false);
    // create a variable to store the component instance
    let recaptchaInstance = null;

    // manually trigger reCAPTCHA execution
    const executeCaptcha = function () {
        recaptchaInstance.execute();
    };

    useEffect(() => {
        getTopics();
        getPropertyPhone({
            params: {
                propertyIdentifier
            },
            callback: (result) => {
                if (result.data) {
                    setResourcePhone(result.data);
                }
            }
        });
    }, []);

    useEffect(() => {
        if (submitInquiry) {
            api.post(`api/${config.controllerName}/${propertyIdentifier}`, resource)
                .then(() => setSubmittedForm(2))
                .catch((error) => globalErrorHandler(error, addError));
        }
    }, [submitInquiry]);

    const getTopics = async () => {
        if (validProperty) {
            const result = await api(`api/${config.controllerName}/topics/${propertyIdentifier}`)
                .catch(error => {
                    globalErrorHandler(error, addError);
                    if (error.response.status === 404) {
                        setValidProperty(false);
                    }
                });

            if (result && result.data) {
                setTopics(result.data);
            }
        }
    };

    const updateResource = (e) => {
        setResource({
            ...resource,
            [e.target.name]: e.target.value
        });

        setResourceIsDirty(true);
    };

    const saveResource = async () => {
        setSubmittedForm(1);
        executeCaptcha();
    };

    const resetForm = () => {
        setResourceIsDirty(false);
        setSubmittedForm(0);
        setResource({});
        recaptchaInstance.reset();
    };

    return (
        (propertyIdentifier && validProperty ?
            <div className="p-1 mx-auto" style={{ overflow: 'hidden', maxWidth: 1200 }}>
                {submittedForm !== 2 ?
                    <div>
                        <Reaptcha
                            ref={e=> (recaptchaInstance = e)}
                            sitekey="6LfICcQfAAAAADjGR31sJqvQwFeSQdyzKvWqMyqr"
                            onVerify={(response) => {
                                console.log('response', response);
                                setSubmitInquiry(true);
                            }}
                            size="invisible"
                            badge="bottomleft"
                        />
                        <Row>
                            <Col md="6" lg="7" xl="8">
                                <Row>
                                    <Col xs="12">
                                        <Field field="name" label="Name" className="mb-2" fieldClassName="rounded-0" value={resource.name} onChange={updateResource} HideHelp />
                                    </Col>
                                    <Col sm="6" md="12" lg="6">
                                        <Field field="email" label="Email" className="mb-2" fieldClassName="rounded-0" value={resource.email} onChange={updateResource} HideHelp />
                                    </Col>
                                    <Col>
                                        <Field field="phone" label="Phone" className="mb-2" fieldClassName="rounded-0" value={resource.phone} onChange={updateResource} HideHelp />
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Field type="select" field="topicId" label="Topic" className="mb-2" fieldClassName="rounded-0" value={resource.topicId} onChange={updateResource} HideHelp>
                                    <option>Select a Topic</option>
                                    {topics && topics.map(topic => <option key={topic.id} value={topic.id}>{topic.name}</option>)}
                                </Field>
                                <Field type="textarea" field="details" label="Details" value={resource.details} fieldClassName={resource.details && resource.details.length > detailCharacterLimit ? 'is-invalid rounded-0' : 'rounded-0'} onChange={updateResource} HideHelp />
                                <div  className="text-dark text-end mb-2"><small>{`${(resource.details || '').length} / ${detailCharacterLimit}`}</small></div>
                            </Col>
                        </Row>
                        <div className="border-top pt-1 mt-1 text-end">
                            <CancelButton color="light" className="border border-dark rounded-0" Close={resetForm} ShowDropdown={false} style={{ marginRight: 3 }}>Reset</CancelButton>
                            <Button color="dark" className="rounded-0" disabled={!resourceIsDirty || submittedForm === 1} onClick={() => saveResource()}>Submit</Button>
                        </div>
                        {errors}
                    </div>
                    :
                    <Row>
                        <Col md="6" lg="4">
                            <h4 className="text-secondary">Submitted!</h4>
                            <p>Thank you for submitting your inquiry. Someone will contact you soon.{resourcePhone && <span> For more immediate assistance, please call <a href={`tel:${resourcePhone}`}>{formatPhoneNumber(resourcePhone)}</a> to be connected with our resource center.</span>}</p>
                            <Button color="link" size="sm" className="p-0" onClick={resetForm}>Begin Another Inquiry</Button>
                        </Col>
                    </Row>
                }
            </div>
            :
            <div>
                <p>Unable to load inquiry form without a <strong>valid property identifier</strong>.</p>
            </div>
        )
    );
};


// WEBPACK FOOTER //
// ./src/components/Inquiries/InquiryForm.js